module.exports = __webpack_public_path__ + "static/media/img_hero_GetFin.a5d70ef2.jpg";